import React, { forwardRef } from 'react';

import { rem, Box, BoxProps, Skeleton } from '@vimeo/bokeh';

export const BokehSkeleton = forwardRef(function (
  { width = '100%', height = rem(16), borderRadius = 'pill', sx, children, ...rest }: BoxProps,
  ref,
) {
  return (
    <Box
      ref={ref}
      overflow={'hidden'}
      width={width}
      height={height}
      borderRadius={borderRadius}
      sx={sx}
      {...rest}
    >
      <Skeleton width={'100%'} height={'100%'} borderRadius={borderRadius}>
        {children}
      </Skeleton>
    </Box>
  );
});
